import { InputHelperText, Labeled, useInput } from "react-admin";
import React, { useCallback, useMemo, useState } from "react";
import { Typography } from "@material-ui/core";
import MYSelectInput from "./MYSelectInput";
import { get } from "lodash";
import moment from "moment";
import { useFormState } from "react-final-form";
import { Group, GroupItem } from "ra-friendsofbabba";

const years = [2019, 2020, 2021, 2022, 2023, 2024, 2025].map((year) => ({
  id: year,
  name: year.toString(),
}));
const months = Array.from(Array(12)).map((x, month) => ({
  name: moment(`2020-${month + 1}-01`, "YYYY-MM-DD").format("MMMM"),
  id: month + 1,
}));

const MYDateInput = ({ lg, md, sm, min, ...props }) => {
  const { label, resource, source } = props;
  const form = useFormState();
  const defaultDate = moment(get(form.values, source, min)).startOf("month");
  const [date, setDate] = useState(defaultDate);
  const {
    input: { onChange },
    meta: { touched, error },
  } = useInput(props);

  const handleChange = useCallback(
    (e) => {
      date.set(
        e.target.name,
        e.target.name === "month" ? e.target.value - 1 : e.target.value
      );
      setDate(date.startOf("month").clone());
      onChange(date.format("YYYY-MM-DD"));
    },
    [date, onChange]
  );
  const hasError = touched && !!error;
  const selectedMonth = useMemo(() => parseInt(date.format("MM"), 10), [date]);
  const selectedYear = useMemo(() => parseInt(date.format("YYYY"), 10), [date]);
  return (
    <Group wrapper>
      <Labeled label={label || `resources.${resource}.fields.${source}`} />
      <Group>
        <GroupItem lg={lg} md={md} sm={sm}>
          <MYSelectInput
            name="month"
            label={
              label
                ? `${label}.month`
                : `resources.${resource}.fields.${source}.month`
            }
            choices={months}
            error={hasError}
            value={selectedMonth}
            onChange={handleChange}
          />
        </GroupItem>
        <GroupItem lg={lg} md={md} sm={sm}>
          <MYSelectInput
            name="year"
            label={
              label
                ? `${label}.year`
                : `resources.${resource}.fields.${source}.year`
            }
            choices={years}
            error={hasError}
            value={selectedYear}
            onChange={handleChange}
          />
        </GroupItem>
      </Group>
      {error && error !== false && touched && (
        <Typography variant="caption">
          <InputHelperText error={error} touched={touched} />
        </Typography>
      )}
    </Group>
  );
};

export default MYDateInput;
